export default "__VITE_ASSET__Bowf$HMz__"